<template>
  <div class="page" v-show="bodyShow">
      <div class="head-wrap">
        <div class="head-title">
          成绩单
        </div>
        <div class="head">
          <div class="head-item " :class="{ active: active==1? true: false}" @click="bandChangeTab(1)">
            <div class="head-item-scores center">{{report.sum_scores}}</div>
            <div class="head-item-desc center">总成绩</div>
          </div>
          <div class="head-item-divider"></div>
          <div class="head-item" :class="{ active: active==2? true: false}" @click="bandChangeTab(2)">
            <div class="head-item-scores center">{{report.user_ranking}} / {{report.sum_user}}</div>
            <div class="head-item-desc center">总排名</div>
          </div>
        </div>
      </div>
      
      <div class="tab-score-wrap" v-if="active==1">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="list">
              <div class="scoreitem"  v-for="(item,index) in scoreslist" :key="index" >
                <div class="scoreitem-type">{{item.code_cn}}</div>
                <div class="scoreitem-title">{{item.desc}}</div>
                <div class="scorebottom">
                  <div class="score-time">{{item.scores_time_cn}}</div>
                  <div class="score-plus">+ {{item.scores}}</div>
                </div>
                <van-divider />
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
      <div class="tab-wrap" v-if="active==2">
        <van-pull-refresh v-model="ranking_refreshing" @refresh="ranking_onRefresh">
          <van-list
            v-model="ranking_loading"
            :finished="ranking_finished"
            finished-text="没有更多了"
            @load="ranking_onLoad"
          >
            <div class="list" >
              <div class="item" v-for="(item,index) in userlist" :key="index" >
                <div class="item-info">
                    <div class="item-info-position">
                      <span v-if="index==0" class="iconfont iconLeaderboard-icon-first mr5 font-size-22"></span>
                      <span v-if="index==1" class="iconfont iconLeaderboard-icon-second mr5 font-size-22"></span>
                      <span v-if="index==2" class="iconfont iconLeaderboard-icon-third mr5 font-size-22"></span>
                      <span v-if="index>2">{{index+1}}</span>
                    </div>
                    <div>
                      <img class="item-user-img" :src="item.photo"/>
                    </div>
                    <div class="item-user-info">
                      <div class="user-info-realname">{{item.user_name}}</div>
                      <div class="user-info-signature">总成绩: {{item.scores}}</div>
                    </div>
                </div>
                <div  class="item-op-zone" >
                  <div class="item-op" v-if="0">关注</div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
  </div>
</template>
<script>
import {Image as VanImage, List, PullRefresh,Divider  } from 'vant';
export default {
  name: "report",
    components:{
      [VanImage.name]:VanImage,
      [List.name]:List,
      [PullRefresh.name]:PullRefresh,
      [Divider.name]:Divider ,
    },
    data(){
        return {
            bodyShow:false,
            active: 1,
            loading: false,
            finished: false,
            refreshing: false,
            page:1,
            pageSize:8,

            ranking_loading: false,
            ranking_finished: false,
            ranking_refreshing: false,
            ranking_page:1,
            ranking_pageSize:10,

            report:{},
            scoreslist:[],
            userlist:[]
        }
    },
    mounted(){

      this.$(document).attr('title','成绩单')
      this.training_stage_id = this.util.getQueryStr('stage_id');
      this.get_scores_summary()
    },
    methods:{
      init(){
        
      },
      get_scores_summary(){
        const _self = this
        this.util.server.mini_training.get_scores_summary({
            data: {
                training_stage_id: this.training_stage_id
            },
            callback: (res => {
                _self.bodyShow = true
                const { code, data, msg } = res
                _self.report = data
                //等页面渲染之后请求
                _self.getScoresRecored()
                
            })
        });
      },
      getScoresRecored(){
          const _self = this
          this.util.server.mini_training.get_scores_recored({
              data: {
                  training_stage_id: this.training_stage_id,
                  page:this.page,
                  pagesize:this.pageSize
              },
              callback: (res => {
                  const { code, data, msg } = res;
                  if(_self.refreshing){
                      _self.refreshing=false;
                  }
                  if(code == 1) {
                      _self.scoreslist = _self.scoreslist.concat(data.items)
                      _self.page ++
                      _self.loading = false
                      if(_self.scoreslist.length >= data.total){
                          _self.finished = true;
                      }
                      
                  }else{
                      _self.util.showToast({
                          message: msg
                      });
                  }
              })
          });
      },
      getScoresRanking(){
          const _self = this
          this.util.server.mini_training.get_scores_ranking({
              data: {
                  training_stage_id: this.training_stage_id,
                  page:this.ranking_page,
                  pagesize:this.ranking_pageSize
              },
              callback: (res => {
                  const { code, data, msg } = res;
                  if(_self.ranking_refreshing){
                      _self.ranking_refreshing=false;
                  }
                  if(code == 1) {
                      _self.userlist = _self.userlist.concat(data.items)
                      _self.ranking_page ++
                      _self.ranking_loading = false
                      if(_self.userlist.length >= data.total){
                        console.log("没有了。。。。")
                        _self.ranking_finished = true;
                      }
                      
                  }else{
                      _self.util.showToast({
                          message: msg
                      });
                  }
              })
          });
      },
      onLoad() {
        this.getScoresRecored()
      },
      onRefresh() {
        this.page = 1
        this.scoreslist =[]
        this.getScoresRecored()
      },

      ranking_onLoad() {
        this.getScoresRanking()
      },
      ranking_onRefresh() {
        this.ranking_page = 1
        this.userlist =[]
        this.getScoresRanking()
      },
      bandChangeTab(item){
          this.active = item
          if(item==2 && this.userlist.length==0){ 
            // 只有等于0的时候，进行切换tab触发
            // TODO 这里需要测试一下 超过高度情况， 点击切换会触发两次，暂时去掉
            //this.getScoresRanking()
          }
          
      }
    }
}
</script>
<style  scoped>
.page{
  background: #FFF;
}
.head-wrap{
  background-color: #ffa500;
}
.head-title{
  font-size: 20px;
  font-weight: 600;
  height: 40px;
  line-height: 40px;
  width: 100%;
  text-align: center;
  color: #FFF;
  padding-top: 15px;
}
.head{
  height: 70px;
  width: 100%;
  display: flex;
}
.head-item{
  flex: 1;
  color: #FFF;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.center{
  text-align: center;
}
.head-item-scores{
  font-size: 20px;
}
.head-item-desc{
  padding-top: 3px;
  font-size: 12px;
}

.item{
  padding: 10px 0px;
  display: flex;
  justify-content: space-between;
}
.item-info{
  display: flex;
}
.item-user-img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    margin-right: 10px;
}
.item-user-info{
  display: flex;
  flex-direction: column;
}
.user-info-realname{
  line-height: 25px;
  height: 25px;
  font-size: 15px;
}
.user-info-signature{
  max-width: 170px;
  color: #9b9b9b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 25px;
  height: 25px;
  font-size: 13px;
}
.item-info-position{
  width: 45px;
  height: 50px;
  line-height: 50px;
  font-size: 12px;
  text-align: center;
}
.item-info-position .iconLeaderboard-icon-first{
  color: #ffd30c;
}
.item-info-position .iconLeaderboard-icon-second{
  color: #f5a623;
}
.item-info-position .iconLeaderboard-icon-third{
  color: #4a90e2;
}
.font-size-22{
  font-size: 22px;
}
.item-op-zone{
  line-height: 50px;
  height: 50px;
}
.item-op{
  height: 25px;
  display: inline;
  background-color: #ffa500;
  color: #FFF;
  padding: 4px 8px;
  border-radius: 4px;
}
.tab-wrap{
  padding: 15px 20px 40px 8px;
}
.tab-score-wrap{
  padding: 15px 20px 20px;
}
.scoreitem{
  /* padding: 5px 0px; */
}
.scorebottom{
  display: flex;
  justify-content: space-between;
}
.scoreitem-type{
  font-size: 15px;
  color: #ffa500;
  font-weight: 600;
}
.scoreitem-title{
  padding: 8px 0;
  font-size: 15px;
}
.scorebottom{
  font-size: 14px;
}
.score-time{
  color:#9b9b9b;
  font-size: 13px;
}
.score-plus{
  color: #ffa500;
}
.head-item-divider{
  width: 1px;
  background-color: #FFF;
  background-color: #FFF;
  margin-top: 0px;
  transform: scale(0.6);
}
.active{
    position:relative;
}
.active:before{
    display:block;
    content:'';
    border-width:8px 8px 8px 8px;
    border-style:solid;
    border-color:transparent transparent #FFF transparent;
    position:absolute;
    bottom: 0px;
    left: calc(50% - 10px);
}
</style>